import { useMemo } from 'react'
import type { DesignPersonalizationContext } from '@vp/personalization-types'
import { useSchemesStore } from '../store/SchemesProvider'

interface UseSchemePreviewDataResult {
  contextId?: string
  contextData?: DesignPersonalizationContext
}

export const useSchemeContext = (schemeId: string): UseSchemePreviewDataResult => {
  const { state } = useSchemesStore()
  const scheme = state.schemes[schemeId]

  const contextId = useMemo(
    () => scheme?.designPersonalizationContext?.designPersonalizationContextId,
    [scheme?.designPersonalizationContext?.designPersonalizationContextId],
  )

  const contextData = useMemo(
    () => scheme?.designPersonalizationContext?.designPersonalizationData,
    [scheme?.designPersonalizationContext?.designPersonalizationData],
  )

  return {
    contextId,
    contextData,
  }
}
